import { useEffect, useState } from "react";

/**
 * The time, re-read every `ms`. One shared timer per interval rather than one per row, so a lead
 * list of a hundred ages costs one tick, not a hundred.
 */
const clocks = new Map<
  number,
  { now: number; subscribers: Set<(n: number) => void>; timer: number }
>();

export function useNow(ms = 1000): number {
  const [now, setNow] = useState(() => clocks.get(ms)?.now ?? Date.now());
  useEffect(() => {
    let clock = clocks.get(ms);
    if (!clock) {
      const created = { now: Date.now(), subscribers: new Set<(n: number) => void>(), timer: 0 };
      created.timer = window.setInterval(() => {
        created.now = Date.now();
        created.subscribers.forEach((fn) => fn(created.now));
      }, ms);
      clocks.set(ms, created);
      clock = created;
    }
    clock.subscribers.add(setNow);
    const c = clock;
    return () => {
      c.subscribers.delete(setNow);
      if (c.subscribers.size === 0) {
        window.clearInterval(c.timer);
        clocks.delete(ms);
      }
    };
  }, [ms]);
  return now;
}
